<div class="tab-section">
    <adapt-display-accordion-hierarchy [hierarchyId]="personHierarchyId"></adapt-display-accordion-hierarchy>
</div>
<div class="tab-section">
    <adapt-display-accordion-hierarchy [hierarchyId]="teamHierarchyId"></adapt-display-accordion-hierarchy>
</div>
<div class="tab-section">
    <adapt-display-accordion-hierarchy [hierarchyId]="organisationHierarchyId"></adapt-display-accordion-hierarchy>
</div>